import React, { Component } from 'react';
import { Form, Row, Col, message } from 'antd';

import { cloneDeep } from 'lodash';

import axios from 'axios';

import PropTypes from 'prop-types';

import { DetailsGroup, AddButton, StepFooter } from '../common';

import Api from '../../../helpers/api';

const api = Api();

class Step12 extends Component {
	constructor(props) {
		super(props);

		const { isInOnboarding = false, stepState = {} } = this.props;

		this.state = {
			isInOnboarding,
			isComplete: isInOnboarding ? stepState.isComplete : false,
			isSkipped: isInOnboarding ? stepState.isSkipped : false,
			isSkippable: isInOnboarding ? stepState.isSkippable : false,
			submittingForm: false,
			teamInfo: [
				{
					firstName: '',
					lastName: '',
					designation: '',
					department: '',
					email: '',
					mobile: '',
				},
			],
			isDataFetched: false,
		};
	}

	componentDidMount() {
		const {
			isInOnboarding = false,
			stepState = { isActive: false },
		} = this.props;

		if (!isInOnboarding || (isInOnboarding && stepState.isActive)) {
			this.fetchTeamInfo('Test-ID1234')
				.then(resp => {
					if (resp.length) {
						this.setState({
							isDataFetched: true,
							teamInfo: [...resp],
						});
						this.props.form.validateFields();
					}
				})
				.catch(err => console.log(err));
		}
	}

	componentDidUpdate() {
		const {
			isInOnboarding = false,
			stepState = { isActive: false },
		} = this.props;
		const { isDataFetched } = this.state;

		if (isInOnboarding && stepState.isActive && !isDataFetched) {
			this.fetchTeamInfo('Test-ID1234')
				.then(resp => {
					if (resp.length) {
						this.setState({
							isDataFetched: true,
							teamInfo: [...resp],
						});
						this.props.form.validateFields();
					}
				})
				.catch(err => console.log(err));
		}
	}

	shouldComponentUpdate(nextProps) {
		if (nextProps.isInOnboarding && nextProps.stepState.isActive !== true) {
			return false;
		}

		return true;
	}

	fetchTeamInfo = async organizationId => {
		const apiUrl = `${api.api}/onboarding/add-team?organizationId=${organizationId}`;

		const apiResponse = await axios.get(apiUrl);

		return apiResponse.data.data;
	};

	onAddTeamGroup = () => {
		this.setState(prevState => ({
			teamInfo: [
				...prevState.teamInfo,
				{
					firstName: '',
					lastName: '',
					designation: '',
					department: '',
					email: '',
					mobile: '',
				},
			],
		}));
	};

	onDeleteMember = userIndex => e => {
		this.setState(prevState => {
			const teamInfo = cloneDeep(prevState.teamInfo);
			teamInfo.splice(userIndex, 1);

			return { teamInfo: [...teamInfo] };
		});
	};

	onSubmit = e => {
		e.preventDefault();

		const { domain, workspace, email } = this.props;

		this.setState({ submittingForm: true });

		const apiUrl = `${api.api}/onboarding/add-team`;

		this.props.form.validateFieldsAndScroll((err, values) => {
			if (!err) {
				console.log('Received values of form: ', values);

				const teamInfo = this.state.teamInfo.map((_, i) => ({
					firstName: values[`firstName${i}`],
					lastName: values[`lastName${i}`],
					designation: values[`designation${i}`],
					department: values[`department${i}`],
					email: values[`email${i}`],
					mobile: values[`mobile${i}`],
				}));

				axios
					.put(apiUrl, {
						organizationId: 'Test-ID1234',
						lastUpdatedEmail: email,
						customerDomain: domain,
						customerWorkspace: workspace,
						teamInfo,
					})
					.then(resp => {
						this.setState({ submittingForm: false });
						message.success('Data Successfully Updated!');

						if (this.state.isInOnboarding) {
							this.props.onStepCompletion();
						}
					})
					.catch(err => console.log(err));
			} else {
				this.setState({ submittingForm: false });
			}
		});
	};

	render() {
		const {
			submittingForm,
			isInOnboarding,
			isSkippable,
			teamInfo,
		} = this.state;
		const { onStepSkip } = this.props;

		const { getFieldDecorator } = this.props.form;

		const formItemLayout = {
			labelCol: {
				xs: { span: 24 },
			},
			wrapperCol: {
				xs: { span: 24 },
			},
		};

		return (
			<Form
				{...formItemLayout}
				layout="vertical"
				onSubmit={this.onSubmit}
			>
				{teamInfo &&
					teamInfo.map((user, i) => (
						<DetailsGroup
							key={i}
							uniqueKey={i}
							groupHeading={`User ${i + 1}`}
							groupType=""
							details={user}
							getFieldDecorator={getFieldDecorator}
							onDelete={this.onDeleteMember}
						/>
					))}
				<Row
					type="flex"
					justify="start"
					align="middle"
					style={{ width: '100%' }}
				>
					<Col>
						<AddButton
							buttonText="Add Member"
							onClick={this.onAddTeamGroup}
						/>
					</Col>
				</Row>
				<StepFooter
					isInOnboarding={isInOnboarding}
					isSkippable={isSkippable}
					isSubmittable={true}
					isLoading={submittingForm}
					onSkip={onStepSkip}
				/>
			</Form>
		);
	}
}

Step12.propTypes = {
	isInOnboarding: PropTypes.bool,
	stepState: PropTypes.object,
	onStepSkip: PropTypes.func,
	onStepCompletion: PropTypes.func,
	domain: PropTypes.string.isRequired,
	workspace: PropTypes.string.isRequired,
	email: PropTypes.string.isRequired,
};

export default Form.create({ name: 'add-team' })(Step12);
